import { OktaAuth } from "@okta/okta-auth-js";

const ISSUER = process.env.REACT_APP_OKTA_ISSUER;
const CLIENT_ID = process.env.REACT_APP_OKTA_CLIENT_ID;
const REDIRECT_URI =
  process.env.REACT_APP_OKTA_REDIRECT_URI || `${window.location.origin}/login`;

export const oktaAuth =
  ISSUER && CLIENT_ID
    ? new OktaAuth({
        issuer: ISSUER,
        clientId: CLIENT_ID,
        redirectUri: REDIRECT_URI,
        scopes: ["openid", "profile", "email"],
        pkce: true,
      })
    : null;

export const isOktaConfigured = Boolean(oktaAuth);
